module.exports = __webpack_public_path__ + "static/media/alexis_ohanian.9bd706db.png";